import styled from 'styled-components/macro';
import { TicketTextRegular } from '../common/fontElements';
import * as colors from 'components/common/colorConstants';

export const ActionItem = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Row = styled(TicketTextRegular)`
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid ${colors.decisionTreeButtonHoverBackground};
  display: flex;
  padding: 12px 32px;
  color: ${colors.black4};
  transition: 0.3s;

  :hover {
    background-color: ${colors.lightGray30};
    color: ${colors.blue1};
  }

  ${(props) =>
    props.dataProtected &&
    `
    background-image: url('/images/new-designs/lock.svg');
    background-repeat: no-repeat;
    background-size: 15px;
    background-position: calc(100% - 20px) center;
  `}
`;
